import Widgets from 'ext:fof/forum-widgets-core/common/extend/Widgets';
import OnlineUsersWidget from './components/OnlineUsersWidget';
export default function (app) {
  new Widgets().add({
    key: 'onlineUsers',
    component: OnlineUsersWidget,
    isDisabled: () => {
      const onlineUsers = app.forum.onlineUsers();
      return Boolean(!app.forum.attribute('canViewOnlineUsersWidget') || !onlineUsers || !onlineUsers.length);
    },
    isUnique: true,
    placement: 'end',
    position: 1
  }).extend(app, 'fof-online-users-widget');
}